// Central booking URL — Google Calendar Appointment Schedule for
// Michael Jesse's 15-min intro calls (Google Meet auto-invite).
// Change this single constant if the booking system ever moves.
export const BOOKING_URL = "https://calendar.app.google/jwqtTK5w8UrAwGUq5";
